((Drupal, drupalSettings) => {
  const { targetCount } = drupalSettings.track_total;

  Drupal.behaviors.wwf_paragraph_countdown = {
    attach(context) {
      const tracks = once("wwf_track_total", ".track-total", context);
      tracks.forEach(async (element) => {
        const trackSettings = drupalSettings.track_total[element.id];
        try {
          const response = await fetch(trackSettings.counterUrl);
          if (!response.ok) {
            console.log(response);
            switch (response.status) {
              case 404:
                element.innerHTML = "Could not find code.";
                break;
              default:
                element.innerHTML = response.text();
            }
          } else {
            const json = await response.json();
            const counterval = json.result[0].q;
            const width = (counterval / trackSettings.targetCount) * 100;
            const barwidth = `${String(width)}%`;
            const progress = element.querySelector(".progress");
            progress.style.width = barwidth;
          }
        } catch (error) {
          element.innerHTML = error.message;
        }
      });
    },
  };
})(Drupal, drupalSettings);
